/* eslint-disable no-undef */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import withTranslate from 'react-redux-multilingual/lib/withTranslate';
import QuoteCardList from 'components/NewQuoteCardList/QuoteCardList';
import { rankSet } from 'Actions/rankingsActions';
import './MarketsOverviewBanner.scss';
import { get } from 'lodash';

class MarketsOverview extends React.Component {
	MarketSymbols = [
		{
			name: 'S&P/TSX COMP',
			hiddenName: this.props.translate('spTsxCompChartHidden'),
			symbol: 'CA;TSEA',
			xid: 593253,
			rankSet: rankSet.TSXComposite
		},
		{
			name: 'DJIA',
			hiddenName: this.props.translate('djiaChartHidden'),
			symbol: 'US&DJI',
			xid: 599362,
			rankSet: rankSet.USDJIA
		},
		{
			name: 'NASDAQ',
			hiddenName: this.props.translate('nasdaqChartHidden'),
			symbol: 'US;COMP',
			xid: 579435,
			rankSet: rankSet.USCOMP
		},
		{
			name: 'S&P 500',
			hiddenName: this.props.translate('sp500ChartHidden'),
			symbol: 'US&SPX',
			xid: 593933,
			rankSet: rankSet.USSPX
		}
	];

	constructor(props) {
		super(props);
	}

	render() {
		const { MarketSymbols } = this;

		return (
			<>
				<div className="main">
					<QuoteCardList
						symbols={MarketSymbols}
						id="new-quote-card-list" />
				</div>
			</>
		);
	}
}

export default withTranslate(MarketsOverview);
